import {FC} from 'react';
import * as _ from 'lodash';
import FAQAccordions from './FAQAccordions';

interface Ifaqs {
  faqs: any;
}
const FAQSection: FC<Ifaqs> = ({faqs}) => {
  let count = 0;
  return (
    <>
      <div className="faq-area">
        <div className="container">
          <div className="faq-accordion">
            {_.map(faqs, (item, index) => {
              count += 1;
              return (
                <FAQAccordions
                  categoryName={index}
                  key={`faq-accordions-${index}-${_.get(
                    item,
                    '[0].id',
                  )}-${count}`}
                  faqs={item}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQSection;
